import {increasing as _increasing} from '@total-order/primitive';

const increasing = (a, b) => _increasing(a, b);
export default increasing;
